<template>
  <div class="backgroundPromo">
    <img class="backgroundPromo__bg img_deks" src="./assets/img/background-promo.png" alt="">
    <img class="backgroundPromo__bg img_mob" src="./assets/img/background-promo-mob.png" alt="">
    <div class="backgroundPromo__wrapper">
      <div class="backgroundPromo__logo">
        <img :src="require(`./assets/img/everyone-${locale}.png`)" alt="" />
      </div>
      <div class="backgroundPromo__influencer img_deks">
        <img
        class="backgroundPromo__left"
        src="./assets/img/background-left.png"
        alt=""
        />
        <img class="backgroundPromo__influencer-img" src="./assets/img/influencer-1.png" alt="" />
      </div>
      <div class="backgroundPromo__influencer img_mob">
        <img
        class="backgroundPromo__left img_mob"
        src="./assets/img/background-left-mob.png"
        alt=""
        />
        <img class="backgroundPromo__influencer-img" src="./assets/img/influencer-3.png" alt="" />
      </div>
      <div class="backgroundPromo__influencer-second ">
        <img
        class="backgroundPromo__right img_deks"
        src="./assets/img/background-right.png"
        alt=""
        />
        <img
        class="backgroundPromo__right img_mob"
        src="./assets/img/background-right-mob.png"
        alt=""
        />
        <img class="backgroundPromo__influencer-second-img " src="./assets/img/influencer-2.png" alt="" />
      </div>
      <a class="backgroundPromo__close" @click="close" v-scroll-to="'#landForm'">{{$t('qic_landing_get_quote_button')}}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BackgroundPromo',
  computed: {
    locale () {
      return this.$i18n.locale
    }
  },
  methods: {
    close () {
      const bg = document.querySelector('.backgroundPromo')
      bg.classList.add('backgroundPromo_hidden')
    }
  }
}
</script>
